import Vue from 'vue';
import VueI18n from 'vue-i18n';

VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
  // this === VueI18n instance, so the locale property also exists here

  if (choice === 0) {
    return 0;
  }

  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;

  if (!teen && endsWithOne) {
    return 1;
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2;
  }

  return (choicesLength < 4) ? 2 : 3;
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'ru',
});

i18n.setLocaleMessage('ru', {
  years: ' {count} лет | {count} год | {count} года | {count} лет',
  months: ' {count} месяцев | {count} месяц | {count} месяца | {count} месяцев',
  days: ' {count} дней | {count} день | {count} дня | {count} дней',
  hours: ' {count} часов | {count} час | {count} часа | {count} часов',
  minutes: ' {count} минут | {count} минута | {count} минут | {count} минут',
  seconds: ' {count} секунд | {count} секунда | {count} секунды | {count} секунд',
  units: ' {count} тем | {count} тема | {count} темы | {count} тем',
  organizations_have: ' {count} организациях | {count} организации | {count} организациях | {count} организациях',
  organizations: ' {count} организаций | {count} организация | {count} организации | {count} организаций',
  modules: ' {count} модулей | {count} модуль | {count} модуля | {count} модулей',
  courses: ' {count} курсов | {count} курс | {count} курса | {count} курсов',
});

export default i18n;
